export const DEFAULT_EMPTY_ERRORS: string[] = [];

export const createErrorMessagesFromMessage = (message: string) =>
  message ? [message] : DEFAULT_EMPTY_ERRORS;
